<template>
  <v-container
    grid-list-xs
    fluid
    class="pa-1"
  >
    <v-layout
      v-if="loading"
      row
      wrap
      justify-center
    >
      <v-progress-circular
        :size="64"
        :width="3"
        indeterminate
        color="primary"
      />
    </v-layout>
    <v-layout
      v-else
      row
      wrap
    >
      <v-toolbar
        style="border-radius:9px"
        color="white"
        light
        tabs
        class="max-shadow"
      >
        <v-toolbar-title>{{ tenant.companyName }}</v-toolbar-title>

        <v-spacer />
        <v-btn
          color="primary"
          flat
          @click.native="deleteTenant"
        >
          Delete
        </v-btn>

        <v-tabs
          slot="extension"
          v-model="activeTab"
          centered
          color="white"
          slider-color="accent"
        >
          <v-tab key="company">
            Company
          </v-tab>
          <v-tab key="invoices">
            Invoices
          </v-tab>
          <v-tab key="recurring-invoices">
            Recurring Invoices
          </v-tab>
          <v-tab key="vault">
            Documents Vault
          </v-tab>
        </v-tabs>
      </v-toolbar>
      <v-flex>
        <v-tabs-items
          :value="activeTab"
          class="pt-2"
        >
          <v-tab-item key="company">
            <company :tenant-id="tenantId" />
          </v-tab-item>
          <v-tab-item key="invoices">
            <invoices :tenant-id="tenantId" />
          </v-tab-item>
          <v-tab-item key="recurring-invoices">
            <recurring-invoices :tenant-id="tenantId" />
          </v-tab-item>
          <v-tab-item key="vault">
            <files-vault :tenant-id="tenantId" />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
      <v-dialog
        v-model="deleteDialog"
        persistent
        max-width="700px"
        transition="dialog-transition"
        lazy
      >
        <v-card class="max-shadow">
          <v-card-title class="headline">
            Remove Tenant?
          </v-card-title>
          <v-card-text class="subheading">
            Do you want to delete tenant {{ tenant.companyName }}'s account?
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-spacer />
            <v-btn
              color="primary"
              flat
              @click="deleteDialog = false"
            >
              cancel
            </v-btn>
            <v-btn
              flat
              color="primary"
              @click="confirmDelete"
            >
              delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { firestore } from '@/firebase';

import FilesVault from './FilesVault';
import Company from './Company';
import Invoices from './Invoices';
import RecurringInvoices from './RecurringInvoices';

export default {
  name: 'Tenant',
  components: {
    company: Company,
    'files-vault': FilesVault,
    invoices: Invoices,
    'recurring-invoices': RecurringInvoices
  },
  props: {
    tenantId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tenant: {},
      loading: true,
      activeTab: null,
      deleteDialog: false
    };
  },
  created() {
    // fetch tenant details
    firestore
      .collection('tenants')
      .doc(this.tenantId)
      .get()
      .then(tenantSnapshot => {
        this.tenant = tenantSnapshot.data();
        this.loading = false;
      });
  },
  methods: {
    deleteTenant(){
      this.deleteDialog = true;
    },

    confirmDelete() {
      firestore
      .collection('tenants')
      .doc(this.tenantId)
      .delete()
      this.deleteDialog = false;
      //route back
      this.$router.back();
    }
  }
};
</script>
